import React, { useContext, useState, useRef, useEffect } from 'react';
import AuthProvider from "../services/AuthProvider";
import {LogIn, User, Lock} from 'react-feather';

import {useForm, FormProvider} from "react-hook-form";
import {ReactComponent as Logo} from '../assets/logo.svg';
import {UiButton} from "./UiButton";
import {Toast} from "primereact/toast";

import './Login.scss'
import UiInputField from "./Form/UiInputField";
import Overlay from "./Overlay";

const LoginPage = () => {
    const { triggerLogin, initLogin } = useContext(AuthProvider);
    const [ isLoading, setIsLoading ] = useState(false);
    const methods = useForm({ defaultValues: {} });
    const { handleSubmit, watch } = methods;
    const toast = useRef(null);
    const allData = watch();

    const toastAlert = (payload) => toast.current?.show(payload);

    const onSubmit = () => {
        setIsLoading(true);
        triggerLogin(allData, (response) => {
            toastAlert({ severity: 'success', summary: 'Sucesso', detail: response.message, life: 3000 });
        }, (response) => {
            toastAlert({ severity: 'error', summary: 'Erro!', detail: response.message, life: 3000 });
            setIsLoading(false);
        });
    };

    useEffect(() => {
        setIsLoading(true);
        initLogin(() => setIsLoading(false), () => setIsLoading(false));
    }, []);

    return <div className="page-login">

        <Overlay show={isLoading} />
        <Toast ref={toast} />

        <div className="logo">
            <Logo />
            <div className="logo-typo">
                <b>Argon</b><br/>Solar
            </div>
        </div>

        <section>
            <h1>Identifique-se</h1>

            <FormProvider {...methods}>
                <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
                    <UiInputField name="login" label="Login" icon={User} />
                    <UiInputField name="senha" label="Senha" type="password" icon={Lock} />
                    <UiButton variant="primary" type="submit"><LogIn size={14} /> Entrar</UiButton>
                </form>
            </FormProvider>
        </section>
    </div>;
}

export default LoginPage;
